import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import Extrafinancial from "./Extrafinancial"
import TirdparyTimePrice from "./TirdparyTimePrice"
import TirdparyUseforPrice from "./TirdparyUseforPrice"
import AddIcon from "@material-ui/icons/Add"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangePriceThirdParty extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  thirdparty_price_id: "",
                  thirdparty_price_forcedthird: "",
                  thirdparty_price_passenger: "",
                  thirdparty_price_yadak: "",
                  thirdparty_price_disc: "",
                  thirdparty_price_disc2: "",
                  selectedCompany: "",
                  selectedMode: "",
                  selectedCarmode: "",
                  selectedCargroup: "",
                  thirdparty_price_deactive: "0",
                  company_logo_url: "",
                  orderBy: "thirdparty_price_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newPriceThirdParty: true,
                  optionCompany: [],
                  optionMode: [],
                  optionCarmode: [],
                  optionCargroup: [],
                  openDialog: false,
                  extraFinancial: [],
                  thirdpartyPriceTime: [],
                  thirdpartyPriceUsefor: [],
                  extrafinancial_price: "",
                  extrafinancial_percent: "",
                  extrafinancial_status: "",
                  thirdpartyprice_time_percent: "",
                  thirdpartyprice_usefor_percent: "",
                  selectedThirdpartyCalmode: "",
                  selectedThirdpartyCoverage: "",
                  selectedThirdpartyTime: "",
                  selectedThirdpartyUsefor: "",
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      handleChangeForcedthird = (event) => {
            this.setState({ thirdparty_price_forcedthird: event })
      }

      handleChangePassenger = (event) => {
            this.setState({ thirdparty_price_passenger: event })
      }

      handleChangeDisc = (event) => {
            this.setState({ thirdparty_price_disc: event })
      }

      handleChangeDisc2 = (event) => {
            this.setState({ thirdparty_price_disc2: event })
      }

      handleChangeYadak = (event) => {
            this.setState({ thirdparty_price_yadak: event })
      }


      handleCargroup = (selectedCargroup) => {
            this.setState({ selectedCargroup: selectedCargroup }, () => {})
      }

      handleCarmode = (selectedCarmode) => {
            this.setState({ selectedCarmode: selectedCarmode }, () => {
                  this.filterPriceThirdParty()
                  this.getoptionCargroup()
            })
      }

      handleMode = (selectedMode) => {
            this.setState({ selectedMode: selectedMode }, () => {
                  this.filterPriceThirdParty()
            })
      }

      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany }, () => {
                  this.filterPriceThirdParty()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ thirdparty_price_deactive: "0" })
            } else {
                  this.setState({ thirdparty_price_deactive: "1" })
            }
      }

      handleThirdpartyCoverage = (selectedThirdpartyCoverage) => {
            this.setState({ selectedThirdpartyCoverage: selectedThirdpartyCoverage })
      }

      handleThirdpartyCalmode = (selectedThirdpartyCalmode) => {
            this.setState({ selectedThirdpartyCalmode: selectedThirdpartyCalmode })
      }

      handleThirdpartyTime = (selectedThirdpartyTime) => {
            this.setState({ selectedThirdpartyTime: selectedThirdpartyTime })
      }

      handleThirdpartyUsefor = (selectedThirdpartyUsefor) => {
            this.setState({ selectedThirdpartyUsefor: selectedThirdpartyUsefor })
      }
      handleChangeExtrafinancialPrice = (event) => {
            this.setState({ extrafinancial_price: event })
      }

      handleChangeExtrafinancialPercent = (event) => {
            this.setState({ extrafinancial_percent: event })
      }
      handleChangeThirdpartyTime = (event) => {
            this.setState({ thirdpartyprice_time_percent: event.target.value })
      }
      handleChangeThirdpartyUsefor = (event) => {
            this.setState({ thirdpartyprice_usefor_percent: event.target.value })
      }

      handleSelectRows = (row2) => {
            this.getextraFinancial(row2.thirdparty_price_id)
            this.getthirdpartyPriceTime(row2.thirdparty_price_id)
            this.getthirdpartyPriceUsefor(row2.thirdparty_price_id)
            this.getoptionThirdpartyUsefor(row2.thirdparty_price_car_mode_id)
            this.setState(
                {
                      thirdparty_price_id: row2.thirdparty_price_id,
                      thirdparty_price_forcedthird: row2.thirdparty_price_forcedthird,
                      thirdparty_price_passenger: row2.thirdparty_price_passenger,
                      thirdparty_price_yadak: row2.thirdparty_price_yadak,
                      thirdparty_price_disc: row2.thirdparty_price_disc,
                      thirdparty_price_disc2: row2.thirdparty_price_disc2,

                      selectedCompany: { value: row2.thirdparty_price_fieldcompany_id, label: row2.company_name, logo: row2.company_logo_url },
                      selectedCarmode: { value: row2.thirdparty_price_car_mode_id, label: row2.carmode_name },
                      selectedMode: { value: row2.thirdparty_price_mode_id, label: row2.thirdparty_mode_desc },
                      selectedCargroup: { value: row2.thirdparty_price_cargroup_id, label: row2.cargroup_name },

                      thirdparty_price_deactive: row2.thirdparty_price_deactive,
                      company_logo_url: row2.company_logo_url,
                      newPriceThirdParty: false,
                },
                () => {}
            )
      }

      newPriceThirdParty = (event) => {
            this.setState({
                  thirdparty_price_id: "",
                  thirdparty_price_forcedthird: "",
                  thirdparty_price_passenger: "",
                  thirdparty_price_yadak: "",
                  thirdparty_price_disc: "",
                  thirdparty_price_disc2: "",
                  selectedCompany: "",
                  selectedCarmode: "",
                  selectedMode: "",
                  selectedCargroup: "",
                  thirdparty_price_deactive: "0",
                  company_logo_url: "",
                  newPriceThirdParty: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getPriceThirdParty()
                                    self.getoptionCarmode()
                                    self.getoptionMode()
                                    self.getoptionThirdpartyCoverage()
                                    self.getoptionThirdpartyCalmode()
                                    self.getoptionThirdpartyTime()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      deleteManagdiscount = () => {
            const { thirdparty_price_id } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getPriceThirdParty()
                              self.newPriceThirdParty()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_thirdparty_price")
            fd.append("thirdparty_price_id", thirdparty_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getPriceThirdParty() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_thirdparty_price")

            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getextraFinancial(thirdparty_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            self.setState({ extraFinancial: [] })
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ extraFinancial: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_extrafinancial")
            fd.append("thirdparty_price_id", thirdparty_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getthirdpartyPriceTime(thirdparty_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            self.setState({ thirdpartyPriceTime: [] }, () => {
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ thirdpartyPriceTime: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_time")
                  fd.append("thirdparty_price_id", thirdparty_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getthirdpartyPriceUsefor(thirdparty_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            self.setState({ thirdpartyPriceUsefor: [] }, () => {
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ thirdpartyPriceUsefor: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_usefor")
                  fd.append("thirdparty_price_id", thirdparty_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getoptionCompany = () => {
            const {
                  optionMode,

            } = this.state
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldcompany_id,
                                          label: arr.data[k].company_name+'('+arr.data[k].fieldinsurance_fa+')',
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company, selectedCompany: Company[0] }, () => {
                                    //  self.filterPriceThirdParty()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldcompany")
            let fieldinsurance = "";
            if (optionMode.length > 0) {
                  for (let i = 0; i < optionMode.length; i++) {
                        fieldinsurance+="'"+optionMode[i].thirdparty_mode_fieldinsurance+"'";
                        if(i < optionMode.length-1){
                              fieldinsurance+=",";
                        }
                  }
            }


            fd.append("allfieldinsurance", fieldinsurance)


            xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
            xhttp.send(fd)
      }

      getoptionCarmode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].carmode_id, label: arr.data[k].carmode_name })
                              }
                              self.setState({ optionCarmode: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_carmode")
            fd.append("fieldinsurance", "thirdpartyins")
            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.send(fd)
      }


      getoptionMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].thirdparty_mode_id, label: arr.data[k].thirdparty_mode_desc,thirdparty_mode_fieldinsurance: arr.data[k].thirdparty_mode_fieldinsurance })
                              }
                              self.setState({ optionMode: Company }, () => {                                    self.getoptionCompany()
                                    self.getoptionCompany()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_mode")
            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.send(fd)
      }

      getoptionThirdpartyCoverage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].thirdparty_coverage_id, label: arr.data[k].thirdparty_coverage_name })
                              }
                              self.setState({ optionThirdpartyCoverage: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_coverage")
            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.send(fd)
      }

      getoptionThirdpartyCalmode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].extrafinancial_calmode_id, label: arr.data[k].extrafinancial_calmode_name })
                              }
                              self.setState({ optionThirdpartyCalmode: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_extrafinancial_calmode")
            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.send(fd)
      }

      getoptionThirdpartyTime = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].thirdparty_time_id, label: arr.data[k].thirdparty_time_name })
                              }
                              self.setState({ optionThirdpartyTime: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_time")
            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.send(fd)
      }

      getoptionThirdpartyUsefor = (thirdparty_price_car_mode_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].usefor_id, label: arr.data[k].usefor_name })
                              }
                              self.setState({ optionThirdpartyUsefor: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_usefor")
            fd.append("carmode_id", thirdparty_price_car_mode_id)
            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.send(fd)
      }

      getoptionCargroup = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].cargroup_id, label: arr.data[k].cargroup_name })
                              }
                              self.setState({ optionCargroup: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_cargroup")
            fd.append("carmode_id", this.state.selectedCarmode.value)
            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.send(fd)
      }

      saveNewPriceThirdParty = () => {
            const {
                  thirdparty_price_forcedthird,
                  thirdparty_price_passenger,
                  thirdparty_price_yadak,
                  thirdparty_price_disc,
                  thirdparty_price_disc2,
                  selectedCompany,
                  selectedCarmode,
                  selectedMode,
                  selectedCargroup,
                  thirdparty_price_deactive,
            } = this.state
            if (
                selectedCompany != "" &&
                selectedCarmode != "" &&
                selectedMode != "" &&
                selectedCargroup != "" &&
                thirdparty_price_forcedthird != "" &&
                thirdparty_price_passenger != "" &&
                thirdparty_price_yadak != ""&&
                thirdparty_price_disc != ""&&
                thirdparty_price_disc2 != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceThirdParty()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_thirdparty_price")
                  fd.append("thirdparty_price_forcedthird", thirdparty_price_forcedthird)
                  fd.append("thirdparty_price_passenger", thirdparty_price_passenger)
                  fd.append("thirdparty_price_yadak", thirdparty_price_yadak)
                  fd.append("thirdparty_price_disc", thirdparty_price_disc)
                  fd.append("thirdparty_price_disc2", thirdparty_price_disc2)

                  fd.append("thirdparty_price_fieldcompany_id", selectedCompany.value)
                  fd.append("thirdparty_price_mode_id", selectedMode.value)
                  fd.append("thirdparty_price_car_mode_id", selectedCarmode.value)
                  fd.append("thirdparty_price_cargroup_id", selectedCargroup.value)
                  fd.append("thirdparty_price_deactive", thirdparty_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceThirdPartyCondition = () => {
            const {
                  thirdparty_price_id,
                  selectedThirdpartyCoverage,
                  selectedThirdpartyCalmode,
                  extrafinancial_price,
                  extrafinancial_percent,
            } = this.state
            if (
                selectedThirdpartyCoverage != "" &&
                selectedThirdpartyCalmode != "" &&
                selectedThirdpartyCalmode != "" &&
                extrafinancial_price != "" &&
                extrafinancial_percent != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({
                                          extrafinancial_price: "",
                                          extrafinancial_percent: "",
                                          selectedThirdpartyCoverage: "",
                                          selectedThirdpartyCalmode: "",
                                    })
                                    self.getextraFinancial(thirdparty_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_extrafinancial")
                  fd.append("extrafinancial_thirdparty_price_id", thirdparty_price_id)
                  fd.append("extrafinancial_price", extrafinancial_price)
                  fd.append("extrafinancial_percent", extrafinancial_percent)
                  fd.append("extrafinancial_extrafinancial_calmode_id", selectedThirdpartyCalmode.value)
                  fd.append("extrafinancial_thirdparty_coverage_id", selectedThirdpartyCoverage.value)

                  xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت مازاد مالی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceThirdPartyTime = () => {
            const { thirdparty_price_id, selectedThirdpartyTime, thirdpartyprice_time_percent } = this.state
            if (selectedThirdpartyTime != "" && thirdpartyprice_time_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ thirdpartyprice_time_percent: "", selectedThirdpartyTime: "" })
                                    self.getthirdpartyPriceTime(thirdparty_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_time")
                  fd.append("thirdpartyprice_time_thirdparty_price_id", thirdparty_price_id)
                  fd.append("thirdpartyprice_time_percent", thirdpartyprice_time_percent)
                  fd.append("thirdpartyprice_time_time_id", selectedThirdpartyTime.value)

                  xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceThirdPartyUsefor = () => {
            const { thirdparty_price_id, selectedThirdpartyUsefor, thirdpartyprice_usefor_percent } = this.state
            if (selectedThirdpartyUsefor != "" && thirdpartyprice_usefor_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ thirdpartyprice_usefor_percent: "", selectedThirdpartyUsefor: "" })
                                    self.getthirdpartyPriceUsefor(thirdparty_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_usefor")
                  fd.append("thirdpartyprice_usefor_thirdparty_price_id", thirdparty_price_id)
                  fd.append("thirdpartyprice_usefor_percent", thirdpartyprice_usefor_percent)
                  fd.append("thirdpartyprice_usefor_usefor_id", selectedThirdpartyUsefor.value)

                  xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changePriceThirdParty = () => {
            const {
                  thirdparty_price_id,
                  thirdparty_price_forcedthird,
                  thirdparty_price_passenger,
                  thirdparty_price_yadak,
                  thirdparty_price_disc,
                  thirdparty_price_disc2,
                  selectedCompany,
                  selectedCarmode,
                  selectedMode,
                  selectedCargroup,
                  thirdparty_price_deactive,
            } = this.state
            if (
                selectedCompany != "" &&
                selectedCarmode != "" &&
                selectedMode != "" &&
                selectedCargroup != "" &&
                thirdparty_price_forcedthird != "" &&
                thirdparty_price_passenger != "" &&
                thirdparty_price_yadak != "" &&
                thirdparty_price_disc != "" &&
                thirdparty_price_disc2 != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceThirdParty()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_thirdparty_price")
                  fd.append("thirdparty_price_id", thirdparty_price_id)
                  fd.append("thirdparty_price_forcedthird", thirdparty_price_forcedthird)
                  fd.append("thirdparty_price_passenger", thirdparty_price_passenger)
                  fd.append("thirdparty_price_yadak", thirdparty_price_yadak)
                  fd.append("thirdparty_price_disc", thirdparty_price_disc)
                  fd.append("thirdparty_price_disc2", thirdparty_price_disc2)

                  fd.append("thirdparty_price_fieldcompany_id", selectedCompany.value)
                  fd.append("thirdparty_price_mode_id", selectedMode.value)
                  fd.append("thirdparty_price_car_mode_id", selectedCarmode.value)
                  fd.append("thirdparty_price_cargroup_id", selectedCargroup.value)
                  fd.append("thirdparty_price_deactive", thirdparty_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                i,
                j,
                temp,
                a,
                b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterPriceThirdParty = () => {
            const { selectedCompany, selectedCarmode, selectedMode, requestinfos } = this.state
            var temparray = requestinfos,
                temparray2 = [],
                i
            for (i = 0; i < temparray.length; i++) {

                  if (
                      (selectedCompany.value === 0 || temparray[i].thirdparty_price_fieldcompany_id === selectedCompany.value) &&
                      (selectedCarmode === "" || selectedCarmode.value === 0 || temparray[i].thirdparty_price_car_mode_id === selectedCarmode.value)
                      // &&              (selectedMode === "" || selectedMode.value === 0 || temparray[i].thirdparty_price_mode_id === selectedMode.value)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  extrafinancial_price,
                  extrafinancial_percent,
                  extrafinancial_status,
                  thirdpartyprice_time_percent,
                  thirdpartyprice_usefor_percent,
                  selectedThirdpartyCalmode,
                  selectedThirdpartyCoverage,
                  selectedThirdpartyTime,
                  selectedThirdpartyUsefor,
                  optionCompany,
                  optionThirdpartyCoverage,
                  optionThirdpartyCalmode,
                  optionThirdpartyTime,
                  optionThirdpartyUsefor,
                  optionMode,
                  optionCarmode,
                  optionCargroup,
                  extraFinancial,
                  thirdpartyPriceTime,
                  thirdpartyPriceUsefor,
                  snackMode,
                  snackstr,
                  showSnack,
                  newPriceThirdParty,
                  thirdparty_price_id,
                  thirdparty_price_forcedthird,
                  thirdparty_price_passenger,
                  thirdparty_price_yadak,
                  thirdparty_price_disc,
                  thirdparty_price_disc2,
                  company_logo_url,
                  selectedCompany,
                  selectedMode,
                  selectedCarmode,
                  selectedCargroup,
                  thirdparty_price_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                      <div className={classes.paperrtl} dir="ltr">
                            <Snackbar
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                onClose={this.handleClickcloseTasckBar}
                                open={showSnack}
                                autoHideDuration={10000}
                            >
                                  <Alert severity={snackMode}>{snackstr}</Alert>
                            </Snackbar>
                            <Grid container spacing={3}>
                                  <Grid item xs={12}>
                                        <Container component="main" maxWidth="lg">
                                              <Paper elevation={4} className={classes.root}>
                                                    <Grid container spacing={3}>
                                                          <Grid item xs={6}>
                                                                <Typography align="center" variant="h7">
                                                                      {"شماره قیمت بیمه ثالث: " + thirdparty_price_id}
                                                                </Typography>
                                                          </Grid>
                                                          <Grid item xs={6}></Grid>

                                                          <Grid item xs={6}></Grid>

                                                          <Grid item xs={6}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <img alt="" className={classes.large} src={this.state.selectedCompany.logo} />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">شرکت بیمه</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"شرکت بیمه"}
                                                                          value={selectedCompany}
                                                                          onChange={this.handleCompany}
                                                                          options={optionCompany}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">نوع اتوموبیل </label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"نوع اتوموبیل "}
                                                                          value={selectedCarmode}
                                                                          onChange={this.handleCarmode}
                                                                          options={optionCarmode}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">نوع  </label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"نوع  "}
                                                                          value={selectedMode}
                                                                          onChange={this.handleMode}
                                                                          options={optionMode}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">گروه اتوموبیل </label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"نوع اتوموبیل "}
                                                                          value={selectedCargroup}
                                                                          onChange={this.handleCargroup}
                                                                          options={optionCargroup}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    type="currency"
                                                                    placeholder="حق بیمه ثالث اجباری"
                                                                    handleInputt={this.handleChangeForcedthird}
                                                                    value={thirdparty_price_forcedthird}
                                                                />
                                                          </Grid>
                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    type="currency"
                                                                    placeholder="حق بیمه سرنشین"
                                                                    handleInputt={this.handleChangePassenger}
                                                                    value={thirdparty_price_passenger}
                                                                />
                                                          </Grid>
                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    type="percent"
                                                                    placeholder="تخفیف"
                                                                    handleInputt={this.handleChangeDisc}
                                                                    value={thirdparty_price_disc}
                                                                />
                                                          </Grid>
                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    type="percent"
                                                                    placeholder=" تخفیف فقط روی ثالث و سرنشین"
                                                                    handleInputt={this.handleChangeDisc2}
                                                                    value={thirdparty_price_disc2}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    type="percent"
                                                                    placeholder="اضافه درصد یدک"
                                                                    handleInputt={this.handleChangeYadak}
                                                                    value={thirdparty_price_yadak}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <FormControlLabel
                                                                          control={
                                                                                <Switch
                                                                                    checked={thirdparty_price_deactive === "0" ? true : false}
                                                                                    onChange={this.handleChangeDeactive}
                                                                                    name="gilad"
                                                                                />
                                                                          }
                                                                          label="وضعیت قیمت شرکت بیمه"
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={12}>
                                                                {newPriceThirdParty ? (
                                                                    <Button
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        onClick={this.saveNewPriceThirdParty}
                                                                    >
                                                                          {"ثبت قیمت بیمه ثالث جدید "}
                                                                    </Button>
                                                                ) : (
                                                                    <div style={{ width: "100%", textAlign: "right" }}>
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.newPriceThirdParty}
                                                                          >
                                                                                {"قیمت بیمه ثالث جدید "}
                                                                          </Button>
                                                                          {"          "}
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.changePriceThirdParty}
                                                                          >
                                                                                {"ثبت تغییرات"}
                                                                          </Button>
                                                                          {"          "}
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.handleClickOpen()
                                                                              }}
                                                                          >
                                                                                {" حذف قیمت بیمه ثالث"}
                                                                          </Button>
                                                                    </div>
                                                                )}
                                                          </Grid>

                                                          {newPriceThirdParty ? null : (
                                                              <Grid item xs={12}>
                                                                    <Divider />
                                                              </Grid>
                                                          )}
                                                    </Grid>
                                              </Paper>
                                        </Container>
                                  </Grid>

                                  <Grid item xs={12}>
                                        <Container>
                                              <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                    {newPriceThirdParty ? null : (
                                                        <Grid item xs={12}>

                                                              {extraFinancial.map((extraFinancial, index) => (
                                                                  <Extrafinancial
                                                                      extraFinancial={extraFinancial}
                                                                      props={this.props}
                                                                      key={index}
                                                                  />
                                                              ))}
                                                        </Grid>
                                                    )}
                                              </Paper>

                                              <Paper className={classes.root}>
                                                    {newPriceThirdParty ? null : (
                                                        <Grid item xs={12}>
                                                              <Grid container spacing={3}>
                                                                    <Grid item xs={3}>
                                                                          <div>
                                                                                <label className="on"> پوشش مالی</label>
                                                                                <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"پوشش مالی"}
                                                                                    value={selectedThirdpartyCoverage}
                                                                                    onChange={this.handleThirdpartyCoverage}
                                                                                    options={optionThirdpartyCoverage}
                                                                                />
                                                                          </div>
                                                                    </Grid>

                                                                    <Grid item item xs={2}>
                                                                          <FloatingLabelInput
                                                                              type="currency"
                                                                              placeholder="قیمت مازاد مالی"
                                                                              handleInputt={this.handleChangeExtrafinancialPrice}
                                                                              value={extrafinancial_price}
                                                                          />
                                                                    </Grid>
                                                                    <Grid item item xs={2}>
                                                                          <FloatingLabelInput
                                                                              placeholder="تخفیف مازاد مالی"
                                                                              type="percent"
                                                                              handleInputt={this.handleChangeExtrafinancialPercent}
                                                                              value={extrafinancial_percent}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item xs={2}>
                                                                          <div>
                                                                                <label className="on"> مدل محاسبه</label>
                                                                                <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"مدل محاسبه"}
                                                                                    value={selectedThirdpartyCalmode}
                                                                                    onChange={this.handleThirdpartyCalmode}
                                                                                    options={optionThirdpartyCalmode}
                                                                                />
                                                                          </div>
                                                                    </Grid>
                                                                    <Grid item item xs={2}>
                                                                          <div style={{ width: "100%", textAlign: "left" }}>
                                                                                <Fab
                                                                                    className={classes.small}
                                                                                    color="primary"
                                                                                    aria-label="add"
                                                                                    onClick={this.saveNewPriceThirdPartyCondition}
                                                                                >
                                                                                      <AddIcon />
                                                                                </Fab>
                                                                          </div>
                                                                    </Grid>
                                                              </Grid>
                                                        </Grid>
                                                    )}
                                              </Paper>
                                        </Container>
                                  </Grid>

                                  <Grid item xs={12}>
                                        <Container>
                                              <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                    {newPriceThirdParty ? null : (
                                                        <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                              {thirdpartyPriceTime.map((thirdpartyPriceTime, index) => (
                                                                  <TirdparyTimePrice
                                                                      thirdpartyPriceTime={thirdpartyPriceTime}
                                                                      props={this.props}
                                                                      key={index}
                                                                  />
                                                              ))}
                                                        </Grid>
                                                    )}
                                              </Paper>
                                              <Paper className={classes.root}>
                                                    {newPriceThirdParty ? null : (
                                                        <Grid item xs={12}>
                                                              <Grid container spacing={3}>
                                                                    <Grid item xs={5}>
                                                                          <div>
                                                                                <label className="on">مدت زمان بیمه نامه </label>
                                                                                <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"مدت زمان بیمه نامه"}
                                                                                    value={selectedThirdpartyTime}
                                                                                    onChange={this.handleThirdpartyTime}
                                                                                    options={optionThirdpartyTime}
                                                                                />
                                                                          </div>
                                                                    </Grid>

                                                                    <Grid item item xs={4}>
                                                                          <FloatingLabelInput
                                                                              placeholder="درصد مدت زمان بیمه نامه"
                                                                              handleInputt={this.handleChangeThirdpartyTime}
                                                                              value={thirdpartyprice_time_percent}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item item xs={3}>
                                                                          <div style={{ width: "100%", textAlign: "left" }}>
                                                                                <Fab
                                                                                    className={classes.small}
                                                                                    color="primary"
                                                                                    aria-label="add"
                                                                                    onClick={this.saveNewPriceThirdPartyTime}
                                                                                >
                                                                                      <AddIcon />
                                                                                </Fab>
                                                                          </div>
                                                                    </Grid>
                                                              </Grid>
                                                        </Grid>
                                                    )}
                                              </Paper>
                                        </Container>
                                  </Grid>

                                  <Grid item xs={12}>
                                        <Container>
                                              <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                    {newPriceThirdParty ? null : (
                                                        <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                              {thirdpartyPriceUsefor.map((thirdpartyPriceUsefor, index) => (
                                                                  <TirdparyUseforPrice
                                                                      thirdparty_price_car_mode_id={selectedCarmode.value}
                                                                      thirdpartyPriceUsefor={thirdpartyPriceUsefor}
                                                                      props={this.props}
                                                                      key={index}
                                                                  />
                                                              ))}
                                                        </Grid>
                                                    )}
                                              </Paper>
                                              <Paper className={classes.root}>
                                                    {newPriceThirdParty ? null : (
                                                        <Grid item xs={12}>
                                                              <Grid container spacing={3}>
                                                                    <Grid item xs={5}>
                                                                          <div>
                                                                                <label className="on">مورد استفاده بیمه نامه </label>
                                                                                <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"مورد استفاده بیمه نامه"}
                                                                                    value={selectedThirdpartyUsefor}
                                                                                    onChange={this.handleThirdpartyUsefor}
                                                                                    options={optionThirdpartyUsefor}
                                                                                />
                                                                          </div>
                                                                    </Grid>

                                                                    <Grid item item xs={4}>
                                                                          <FloatingLabelInput
                                                                              placeholder="درصد مورد استفاده بیمه نامه"
                                                                              handleInputt={this.handleChangeThirdpartyUsefor}
                                                                              value={thirdpartyprice_usefor_percent}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item item xs={3}>
                                                                          <div style={{ width: "100%", textAlign: "left" }}>
                                                                                <Fab
                                                                                    className={classes.small}
                                                                                    color="primary"
                                                                                    aria-label="add"
                                                                                    onClick={this.saveNewPriceThirdPartyUsefor}
                                                                                >
                                                                                      <AddIcon />
                                                                                </Fab>
                                                                          </div>
                                                                    </Grid>
                                                              </Grid>
                                                        </Grid>
                                                    )}
                                              </Paper>
                                        </Container>
                                  </Grid>

                                  <Grid item xs={12}>
                                        <Container maxWidth="lg">
                                              <Paper className={classes.root}>
                                                    <TableContainer dir="rtl">
                                                          <Table aria-label="sticky table">
                                                                <TableHead>
                                                                      <TableRow>
                                                                            <TableCell
                                                                                key={"thirdparty_price_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                                sortDirection={orderBy === "thirdparty_price_id" ? order : false}
                                                                            >
                                                                                  {" آی دی "}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "thirdparty_price_id"}
                                                                                      direction={
                                                                                            orderBy === "thirdparty_price_id" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("thirdparty_price_id")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"company_name"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"شرکت بیمه  "}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "company_name"}
                                                                                      direction={orderBy === "company_name" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("company_name")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"thirdparty_price_mode_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"نوع طرح"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "thirdparty_price_mode_id"}
                                                                                      direction={
                                                                                            orderBy === "thirdparty_price_mode_id"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("thirdparty_price_mode_id")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"thirdparty_price_car_mode_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"نوع اتوموبیل"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "thirdparty_price_car_mode_id"}
                                                                                      direction={
                                                                                            orderBy === "thirdparty_price_car_mode_id"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("thirdparty_price_car_mode_id")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"thirdparty_price_cargroup_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"گروه خودرو"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "thirdparty_price_cargroup_id"}
                                                                                      direction={
                                                                                            orderBy === "thirdparty_price_cargroup_id"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("thirdparty_price_cargroup_id")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"thirdparty_price_forcedthird"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"ثالث اجباری"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "thirdparty_price_forcedthird"}
                                                                                      direction={
                                                                                            orderBy === "thirdparty_price_forcedthird"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("thirdparty_price_forcedthird")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"thirdparty_price_passenger"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"حق بیمه سرنشین"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "thirdparty_price_passenger"}
                                                                                      direction={
                                                                                            orderBy === "thirdparty_price_passenger"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("thirdparty_price_passenger")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"thirdparty_price_disc"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"تخفیف"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "thirdparty_price_disc"}
                                                                                      direction={
                                                                                            orderBy === "thirdparty_price_disc" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("thirdparty_price_disc")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"thirdparty_price_disc2"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"تخفیف ثالث و سرنشین"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "thirdparty_price_disc2"}
                                                                                      direction={
                                                                                            orderBy === "thirdparty_price_disc2" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("thirdparty_price_disc2")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"thirdparty_price_yadak"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"اضافه درصد یدک"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "thirdparty_price_yadak"}
                                                                                      direction={
                                                                                            orderBy === "thirdparty_price_yadak" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("thirdparty_price_yadak")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"thirdparty_price_deactive"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                            >
                                                                                  {"وضعیت قیمت بیمه ثالث"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "thirdparty_price_deactive"}
                                                                                      direction={
                                                                                            orderBy === "thirdparty_price_deactive"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("thirdparty_price_deactive")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                      </TableRow>
                                                                </TableHead>

                                                                <TableBody>
                                                                      {agentInfofilter
                                                                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                          .map((row) => {
                                                                                return (
                                                                                    <TableRow
                                                                                        hover
                                                                                        role="checkbox"
                                                                                        tabIndex={-1}
                                                                                        key={row["thirdparty_price_id"]}
                                                                                        value={row}
                                                                                        onClick={() => {
                                                                                              this.handleSelectRows(row)
                                                                                        }}
                                                                                    >
                                                                                          <TableCell
                                                                                              key={"thirdparty_price_id"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["thirdparty_price_id"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"company_name"} align={"center"}>
                                                                                                {row["company_name"]}
                                                                                                <img
                                                                                                    className={classes.small}
                                                                                                    alt="Remy Sharp"
                                                                                                    src={row["company_logo_url"]}
                                                                                                />
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"thirdparty_price_mode_id"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["thirdparty_mode_desc"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"thirdparty_price_car_mode_id"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["carmode_name"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"thirdparty_price_cargroup_id"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["cargroup_name"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"thirdparty_price_forcedthird"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["thirdparty_price_forcedthird"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"thirdparty_price_passenger"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["thirdparty_price_passenger"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"thirdparty_price_disc"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["thirdparty_price_disc"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"thirdparty_price_disc2"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["thirdparty_price_disc2"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"thirdparty_price_yadak"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["thirdparty_price_yadak"]}
                                                                                          </TableCell>


                                                                                          <TableCell
                                                                                              key={"thirdparty_price_deactive"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["thirdparty_price_deactive"] === "1" ||
                                                                                                row["thirdparty_price_deactive"] === 1 ? (
                                                                                                    <Fab variant="extended">
                                                                                                          <VoiceOverOffIcon />
                                                                                                          {"غیر فعال"}
                                                                                                    </Fab>
                                                                                                ) : (
                                                                                                    <Fab
                                                                                                        variant="extended"
                                                                                                        style={{ background: "#44b700" }}
                                                                                                    >
                                                                                                          <RecordVoiceOverIcon />
                                                                                                          {"فعال"}
                                                                                                    </Fab>
                                                                                                )}
                                                                                          </TableCell>
                                                                                    </TableRow>
                                                                                )
                                                                          })}
                                                                </TableBody>
                                                          </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[10, 25, 100]}
                                                        component="div"
                                                        count={agentInfofilter.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onChangePage={this.handleChangePage}
                                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                    />
                                              </Paper>
                                        </Container>
                                  </Grid>
                            </Grid>

                            {okstatus ? (
                                <Alert severity="success">
                                      <AlertTitle>پیام</AlertTitle>
                                      {errstr}
                                </Alert>
                            ) : null}
                            <Dialog
                                open={this.state.openDialog}
                                onClose={this.handleClose}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                  <DialogTitle id="alert-dialog-title">{"آیا میخواهید قیمت بیمه ثالث را حذف نمایید"}</DialogTitle>
                                  <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                              ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                        </DialogContentText>
                                  </DialogContent>
                                  <DialogActions>
                                        <Button onClick={this.handleClose} color="primary">
                                              انصراف
                                        </Button>
                                        <Button onClick={this.deleteManagdiscount} color="primary" autoFocus>
                                              بله انجام شود
                                        </Button>
                                  </DialogActions>
                            </Dialog>
                      </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangePriceThirdParty)
